export function riskLevelsEnabled(): boolean {
  return import.meta.env.VITE_SHOW_RISK_LEVELS !== "false";
}

export function orderRevertEnabled(): boolean {
  return import.meta.env.VITE_ORDER_REVERT === "true";
}
